module.exports = __webpack_public_path__ + "static/img/5.ddf048c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/7/5.png
// module id = /p7x
// module chunks = 0